declare namespace $ {

	type $mol_view__sub_shm_wordstat_region_select_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_check_all__checks_shm_wordstat_region_select_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['select_all_checks'] >
		,
		ReturnType< $shm_check_all['checks'] >
	>
	type $shm_check_all__title_shm_wordstat_region_select_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_check_all['title'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_4 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['title_line_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_wordstat_region_select_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_region_select_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['preset_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check__title_shm_wordstat_region_select_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_shm_wordstat_region_select_9 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['preset_districts_checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__style_shm_wordstat_region_select_10 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_wordstat_region_select['preset_districts_color'] >,
		})  & ReturnType< $mol_check['style'] >
		,
		ReturnType< $mol_check['style'] >
	>
	type $mol_check__title_shm_wordstat_region_select_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_shm_wordstat_region_select_12 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['preset_areas_checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__style_shm_wordstat_region_select_13 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_wordstat_region_select['preset_areas_color'] >,
		})  & ReturnType< $mol_check['style'] >
		,
		ReturnType< $mol_check['style'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_15 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['presets_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_shm_wordstat_region_select_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_wordstat_region_select_17 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['search'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_18 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['tree_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_expand__checked_shm_wordstat_region_select_19 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['node_expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_wordstat_region_select_20 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['node_expandable'] >
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_check_box__checked_shm_wordstat_region_select_21 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['row_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_wordstat_region_select_22 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['row_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_button_minor__title_shm_wordstat_region_select_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_region_select_24 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['row_only'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_wordstat_region_select_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_region_select_27 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['collapse_all'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_28 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_29 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['title_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_wordstat_region_select_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_region_select_34 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['collapse_all'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_35 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['node_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_region_select_37 = $mol_type_enforce<
		ReturnType< $shm_wordstat_region_select['node_children'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_wordstat_region_select extends $mol_view {
		section_rows( ): readonly(any)[]
		Label( ): $mol_view
		select_all_checks( ): readonly(any)[]
		Select_all( ): $shm_check_all
		title_line_content( ): readonly(any)[]
		Title_line( ): $mol_view
		summary( ): string
		Summary( ): $mol_view
		title_content( ): readonly(any)[]
		preset_reset( next?: any ): any
		Preset_reset( ): $mol_button_minor
		preset_districts_checked( next?: boolean ): boolean
		preset_districts_color( ): string
		Preset_districts( ): $mol_check
		preset_areas_checked( next?: boolean ): boolean
		preset_areas_color( ): string
		Preset_areas( ): $mol_check
		Preset_actions( ): $mol_view
		presets_content( ): readonly(any)[]
		Presets( ): $mol_view
		Search( ): $mol_string
		tree_content( ): readonly(any)[]
		Tree( ): $mol_view
		error_text( next?: string ): string
		collapse_all( next?: any ): any
		node_rows( id: any): readonly(any)[]
		node_expanded( id: any, next?: boolean ): boolean
		node_expandable( id: any): boolean
		Row_expand( id: any): $mol_check_expand
		row_checked( id: any, next?: boolean ): boolean
		row_title( id: any): string
		Row_check( id: any): $mol_check_box
		row_only( id: any, next?: any ): any
		Row_only( id: any): $mol_button_minor
		Row_label( id: any): $mol_view
		Row_collapse( id: any): $mol_button_minor
		row_content( id: any): readonly(any)[]
		Row_content( id: any): $mol_view
		node_children( id: any): readonly(any)[]
		regions( next?: string ): string
		search( next?: string ): string
		tree( ): any
		allowed_ids( ): readonly(any)[]
		presets_visible( ): boolean
		select_all_visible( ): boolean
		only_visible( ): boolean
		sub( ): ReturnType< $shm_wordstat_region_select['section_rows'] >
		Title( ): $mol_view
		Content( ): $mol_view
		Empty( ): $mol_view
		Error( ): $mol_view
		Preset_collapse( ): $mol_button_minor
		Node( id: any): $mol_view
		Row( id: any): $mol_view
		Children( id: any): $mol_view
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map